import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AtaraxiaOnDestroyDirective } from '@epicuro-next/ataraxia/on-destroy';
import { PopoverDirectiveInputs } from '@epicuro-next/ataraxia/popover';
import { dynamicElementsPopoverWrapperKey } from '@epicuro-next/constants/dynamic-elements';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { ensureArray } from '@epicuro-next/utilities';

@DynamicComponentRegister(dynamicElementsPopoverWrapperKey, true)
@Component({
  selector: 'epc-dynamic-elements-popover-wrapper',
  templateUrl: './popover-wrapper.component.html',
  styleUrls: ['./popover-wrapper.component.scss'],
  hostDirectives: [AtaraxiaOnDestroyDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicElementsPopoverWrapperComponent extends PopoverDirectiveInputs {
  @Input() public triggerContent: IDynamicItem | IDynamicItem[] = [];
  @Input() public popoverContent: IDynamicItem | IDynamicItem[] = [];

  @Input()
  public set scope(value: object) {
    this.__scope__ = value;
  }
  public get scope(): object {
    return this.__scope__ ?? this;
  }
  // tslint:disable-next-line:variable-name
  private __scope__?: object;

  constructor() {
    super();
  }

  public get dynamicTriggerContentItems(): IDynamicItem[] {
    return ensureArray(this.triggerContent);
  }

  public get dynamicPopoverContentItems(): IDynamicItem[] {
    return ensureArray(this.popoverContent);
  }
}
